import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export interface BrandLogoProps {
  title?: string;
  subtitle?: string;
  to?: string;
  className?: string;
}

/**
 * BrandLogo component displays the GraymatterLab brand with an optional subtitle.
 * Links to the home/dashboard page.
 */
export const BrandLogo: React.FC<BrandLogoProps> = ({
  title = 'GraymatterLab',
  subtitle = 'Agent Architect',
  to = '/',
  className = '',
}) => {
  return (
    <RouterLink
      to={to}
      className={`
        flex flex-col hover:opacity-80 transition-opacity
        ${className}
      `
        .trim()
        .replace(/\s+/g, ' ')}
    >
      <span className="text-2xl font-bold text-secondary-900 dark:text-white leading-tight">
        {title}
      </span>
      <span className="text-base text-secondary-500 dark:text-secondary-400 leading-tight">
        {subtitle}
      </span>
    </RouterLink>
  );
};

export default BrandLogo;
